











































































































































import Vue from "vue";
import Component from "vue-class-component";
import QNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";
import { FinancialManagerService } from "@/common/api";
import qNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import QSelect2 from "@/common/qSelect2.vue";
import uploadFile from "@/components/common/uploadFile.vue";
import { TYPES } from "@/model/financial";
import _isEmpty from "lodash/isEmpty";

@Component({
  name: "FinancialAdd",
  components: {
    QSelect2,
    QErrors,
    uploadFile,
  },
})
export default class FinancialAdd extends Vue {
  public isShow = false;
  public isEdit = false;
  public errors: any = {};
  public errorStyle = {
    maxWidth: "100%",
  };
  public financial: any = {};

  public types = TYPES;

  public initForm: any = {};

  public form: any = {};

  public files: any = [{}];
  public fileUploadStatus = "";
  public uploadFileIndex = null;

  get isFileUploading() {
    return this.fileUploadStatus === "uploading";
  }

  public uploadOptions = {
    maxFilesize: 2, // 2mb
    acceptedFiles: ".pdf",
  };

  get years() {
    const currentYear = new Date().getFullYear();
    return {
      [currentYear]: currentYear,
      [currentYear - 1]: currentYear - 1,
      [currentYear - 2]: currentYear - 2,
    };
  }

  public clearForm() {
    const currentYear = new Date().getFullYear();
    this.initForm = {
      year: currentYear,
      type: "決算短信",
      fileIds: [],
    };
    this.form = { ...this.initForm };
    this.errors = {};
    this.financial = {};
    this.isEdit = false;
    this.files = [{}];
    this.fileUploadStatus = "";
    (this.$refs.myVueDropzone as uploadFile).removeAllFile();
  }

  public show(financial = null) {
    this.clearForm();

    if (financial) {
      this.isEdit = true;
      this.financial = financial;
      this.form = {
        year: financial.year,
        type: financial.type,
        fileIds: financial.files.map((file) => file.id),
      };
      this.files = [...financial.files];
      this.initForm = { ...this.form };
    }

    this.isShow = true;
  }

  async addFinancial() {
    this.errors = {};
    let result;
    try {
      result = await FinancialManagerService.financialCreate(this.form);
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      qNotify.success({
        text: this.$t("common.message.created"),
      });
      this.isShow = false;
      this.$emit("closeAdded");
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  async editFinancial() {
    this.errors = {};
    let result;
    try {
      result = await FinancialManagerService.financialEdit({
        ...this.form,
        ...{ id: this.financial.id },
      });
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      qNotify.success({
        text: this.$t("common.message.updated"),
      });
      this.$emit("closeEdited", result.data.Financial);
      this.isShow = false;
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  public confirmDeleteFinancial() {
    this.errors = {};
    this.$modal.showDelete({
      text: this.$t("common.modal.delete_content"),
      onConfirm: () => {
        this.deleteFinancial();
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  async deleteFinancial() {
    let result;
    try {
      result = await FinancialManagerService.financialDelete({
        id: this.financial.id,
      });
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      qNotify.success({
        text: this.$t("common.message.deleted"),
      });
      this.isShow = false;
      this.$emit("closeEdited");
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }
  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: `${this.$t("common.modal.cancel_content")}`,
        confirmText: `${this.$t("common.buttons.yes")}`,
        cancelText: `${this.$t("common.buttons.no")}`,
        onConfirm: () => {
          this.isShow = false;
        },
      });
    } else {
      this.isShow = false;
    }
  }

  public isChanged() {
    return !compareWithKeys(this.form, this.initForm, [
      "year",
      "type",
      "fileIds",
    ]);
  }

  public changeFile(files, isRemove) {
    this.errors.fileIds = [];
    if (isRemove) {
      if (files.length > 0) {
        this.files.splice(this.uploadFileIndex, 1);
      } else {
        this.files = [{}];
      }
    } else {
      this.files[this.uploadFileIndex] = files[0];
    }

    this.form.fileIds = this.files
      .filter((file) => {
        return !_isEmpty(file);
      })
      .map((file) => file.id);
    this.uploadFileIndex = null;
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public pushError(message) {
    this.errors = {
      ...this.errors,
      ...{ fileIds: [message] },
    };
  }

  public addFile() {
    this.files.push({});
  }

  public isEmpty(object) {
    return _isEmpty(object);
  }

  public openFile(index) {
    this.uploadFileIndex = index;
    (this.$refs.myVueDropzone as uploadFile).open();
  }
  public removeFile(index) {
    this.uploadFileIndex = index;
    (this.$refs.myVueDropzone as uploadFile).removeFile(
      this.files[index],
      index
    );
  }
}
